export function StyleJustifier (pEditor, pStyle)
{
  this.queryJustifyEnabled = (pButton, command) =>
  {
    let rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();

    if (rangeElement)
    {
      return (command !== 'justifyfull');
    }
    else
    {
      if (command.indexOf('justify') === 0)
      {
        return pEditor.queryBasicCommandEnabled(pButton, ((command === 'justify') ? 'justifyleft' : command));
      }
      else
      {
        return false;
      }
    }
  };


  this.queryJustifyState = (pButton, command) =>
  {
    let checkBlockTags = /^(p|h[1-6]|div|pre|li|blockquote|center|dt|dd|th|td|address|marquee)$/i,
        rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();

    if (rangeElement)
    {
      return false;
    }
    else
    {
      if (command.indexOf('justify') === 0)
      {
        if (!BEditor.browser.isIE)
        {
          let currentRange = pEditor.range.getCurrent();

          if (currentRange)
          {
            let startBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, checkBlockTags);

            while (startBlockElement && startBlockElement.nodeName !== 'TH' && startBlockElement.nodeName !== 'TD' && !startBlockElement.getAttribute('align'))
            {
              startBlockElement = startBlockElement.parentNode;
              startBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(startBlockElement, checkBlockTags);
            }

            if (startBlockElement)
            {
              let currentJustify = startBlockElement.getAttribute('align');

              if (!currentJustify)
              {
                currentJustify = 'left';
              }

              currentJustify = 'justify' +  ((currentJustify.toLowerCase() === 'justify') ? 'full' : currentJustify.toLowerCase());
              return (currentJustify === ((command === 'justify') ? 'justifyleft' : command.toLowerCase()));
            }
          }
        }
        else
        {
          return pEditor.queryBasicCommandState(pButton, ((command === 'justify') ? 'justifyleft' : command));
        }
      }

      return false;
    }
  };


  const webKitNormalizeJustify = () =>
  {
    if (BEditor.browser.isWebKit)
    {
      const elements = pEditor.iFrameDoc.body.querySelectorAll('[style*="text-align"]');

      for (let i = 0; i < elements.length; i++)
      {
        if (elements[i].style.textAlign !== '')
        {
          if (elements[i].nodeName === 'LI')
          {
            elements[i].innerHTML = `<div align="${elements[i].style.textAlign.replace(/^.*?(left|center|right|justify).*$/i, '$1')}">${elements[i].innerHTML}</div>`;
          }
          else
          {
            elements[i].setAttribute('align', elements[i].style.textAlign.replace(/^.*?(left|center|right|justify).*$/i, '$1'));
          }

          elements[i].style.textAlign = '';

          if (elements[i].getAttribute('style') === '')
          {
            elements[i].removeAttribute('style');
          }
        }

        if (elements[i].nodeName === 'DIV' && !elements[i].hasAttribute('data-wacontent'))
        {
          let divParent = pEditor.helpers.element.getParentElementFromElementByTagsNames(elements[i].parentNode, pEditor.checkAllBlockTags);

          if (divParent || (divParent && divParent.nodeName === 'LI'))
          {
            if ((/(?:P|H[1-6])/i).test(divParent.nodeName))
            {
              divParent.setAttribute('align', elements[i].getAttribute('align'));
              elements[i].outerHTML = elements[i].innerHTML;
            }
          }
          else
          {
            elements[i].outerHTML = elements[i].outerHTML.replace(/^<div/i, '<p').replace(/div>$/i, 'p>');
          }
        }
      }

      edgeNormalizeJustify();
    }
  };


  const edgeNormalizeJustify = () =>
  {
    if (BEditor.browser.isEdge)
    {
      const elements = pEditor.iFrameDoc.body.querySelectorAll('DIV:not([data-wacontent])[align]');

      for (let i = 0; i < elements.length; i++)
      {
        if (elements[i].innerHTML.replace(/(?:\s|<br>)*/ig, '') === '')
        {
          elements[i].outerHTML = elements[i].innerHTML.replace(/[^\s]/g, '');
        }
      }
    }
  };


  this.execJustify = (pButton, command) => //TODO:Dime Bug in WebKit - extra styles (font size) on inner tags
  {
    let elements,
        isOnlyTrueNodes = true,
        rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();

    pEditor.range.stopCheckSelection();

    if (rangeElement)
    {
      execJustifyDo(rangeElement, command);
    }
    else
    {
      if (command.indexOf('justify') === 0)
      {
        let currentRange = pEditor.range.getCurrent(true);

        if (currentRange)
        {
          elements = pEditor.helpers.element.getElementsInRangeByTagsNames(currentRange, /^(?:P|H[1-6])$/i);

          if (elements && elements.length > 0)
          {
            for (let i = 0; i < elements.length - 1; i++)
            {
              let nextSiblingNode = elements[i].nextSibling;

              while (nextSiblingNode && nextSiblingNode.nodeType === 3 && nextSiblingNode.nodeValue.replace(/\s+/g, '') === '')
              {
                nextSiblingNode = nextSiblingNode.nextSibling;
              }

              if (!(nextSiblingNode && nextSiblingNode.isSameNode(elements[i + 1])))
              {
                isOnlyTrueNodes = false;
                break;
              }
            }
          }
          else
          {
            isOnlyTrueNodes = false;
          }
        }
        else
        {
          isOnlyTrueNodes = false;
        }

        if (isOnlyTrueNodes)
        {
          for (let i = 0; i < elements.length; i++)
          {
            elements[i].setAttribute('align', ((command.substring(7) === 'full') ? 'justify' : command.substring(7)));
          }
        }
        else
        {
          if (BEditor.browser.isWebKit && command === 'justifyleft' && pEditor.queryBasicCommandState(pButton, 'justifyleft'))
          {
            pEditor.execBasicCommand(pButton, 'justifycenter');
          }

          pEditor.execBasicCommand(pButton, command, {afterCallback: webKitNormalizeJustify});
        }
      }
    }

    pEditor.range.restoreBookmark();
  };


  function execJustifyDo(element, command)
  {
    if (command === 'justifyleft')
    {
      element.style.left = '0px';
    }
    else if (command === 'justifycenter')
    {
      element.style.left = (Math.floor((pEditor.iFrameDoc.body.offsetWidth - element.offsetWidth) / 2)) + 'px';
    }
    else if (command === 'justifyright')
    {
      element.style.left = (pEditor.iFrameDoc.body.offsetWidth - element.offsetWidth) + 'px';
    }
    else if (command === 'justifytop')
    {
      element.style.top = '0px';
    }
    else if (command === 'justifymiddle')
    {
      element.style.top = (Math.floor((pEditor.iFrameDoc.body.offsetHeight - element.offsetHeight) / 2)) + 'px';
    }
    else if (command === 'justifybottom')
    {
      element.style.top = (pEditor.iFrameDoc.body.offsetHeight - element.offsetHeight) + 'px';
    }

    if (!BEditor.browser.isIE)
    {
      pEditor.objIFrame.style.overflow = 'visible';
      setTimeout(function() { pEditor.objIFrame.style.overflow = 'hidden'; pEditor.pThis.focus(); }, 1);
    }
  }


  this.webKitNormalizeJustify = webKitNormalizeJustify;
}